import { useState } from "react";


export const useColors =()=>{
    
    const [Colors, setColors] = useState({
      
        primary: "",
        secondary: "",
        success: "",
        warning: "",
        error: "",
        info: "",
        background: "",
        text: ""
    });
  
    return {
        Colors,
        setColors
    };
} 




